if (!customElements.get('product-reference-drawer')) {
  customElements.define(
    'product-reference-drawer',
    class ProductReferenceDrawer extends HTMLElement {
      connectedCallback() {
        this._handleChange = this._handleChange.bind(this);
        this.addEventListener('change', this._handleChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._handleChange);
      }

      _handleChange(event) {
        const { target } = event;
        if (target.type !== 'radio' || !target.dataset.productUrl) return;

        // Stop propagation so the variant-picker doesn't also respond to this change
        // (it would call fetchUpdatedSection on the current URL, reverting the UI).
        event.stopPropagation();

        const targetUrl = target.dataset.productUrl;
        const currentUrl = (this.dataset.productUrl || '').replace(/\?.*$/, '');
        const cleanTarget = targetUrl.replace(/\?.*$/, '');

        this.querySelector('dialog')?.close();

        if (cleanTarget === currentUrl) return;
        document.body.classList.add('is-navigating');
        this._navigate(targetUrl);
      }

      async _navigate(targetProductUrl) {
        const cleanUrl = targetProductUrl.replace(/\?.*$/, '');

        let fetchUrl = cleanUrl;
        try {
          const variantId = await this._findMatchingVariantId(cleanUrl);
          if (variantId) fetchUrl = `${cleanUrl}?variant=${variantId}`;
        } catch {
          // Proceed without variant selection
        }

        window.location.href = fetchUrl;
      }

      async _findMatchingVariantId(targetUrl) {
        const variantPicker = document.querySelector(
          'variant-picker[data-template-product-match="true"]'
        );
        const variantScript = variantPicker?.querySelector(
          'script[type="application/json"]:not([data-variants-cache])'
        );

        if (!variantScript) return null;

        let currentVariant;
        try {
          currentVariant = JSON.parse(variantScript.textContent);
        } catch {
          return null;
        }

        if (!currentVariant) return null;

        const currentValues = new Set(
          [currentVariant.option1, currentVariant.option2, currentVariant.option3].filter(Boolean)
        );

        if (currentValues.size === 0) return null;

        const { product } = await fetch(`${targetUrl}.json`).then((r) => r.json());

        if (!Array.isArray(product?.variants) || product.variants.length === 0) return null;

        const scored = product.variants.map((v) => {
          const vals = [v.option1, v.option2, v.option3].filter(Boolean);
          const score = vals.filter((val) => currentValues.has(val)).length;
          return { v, score };
        });

        scored.sort((a, b) => {
          if (b.score !== a.score) return b.score - a.score;
          // Prefer available variant on a tie
          return (b.v.available ? 1 : 0) - (a.v.available ? 1 : 0);
        });

        return scored[0]?.score > 0 ? scored[0].v.id : null;
      }
    }
  );
}
